export const configConstants = {
  GET_ANNEES: "GET_ANNEES",
  GET_ANNEE: "GET_ANNEE",

  GET_ECHEANCES: "GET_ECHEANCES",
  GET_ECHEANCE: "GET_ECHEANCE",

  GET_CATEGORIES: "GET_CATEGORIES",
  GET_CATEGORIE: "GET_CATEGORIES",

  GET_DOMAINES: "GET_DOMAINES",
  GET_ALL_DOMAINES: "GET_ALL_DOMAINES",
  GET_DOMAINE: "GET_DOMAINE",

  GET_MENTIONS: "GET_MENTIONS",
  GET_MENTIONS_BY_DOMAINES: "GET_MENTIONS_BY_DOMAINES",
  GET_MENTION: "GET_MENTION",

  GET_SESSIONS: "GET_SESSIONS",

  GET_SPECIALITES: "GET_SPECIALITES",
  GET_SPECIALITES_BY_MENTIONS: "GET_SPECIALITES_BY_MENTIONS",
  GET_SPECIALITE: "GET_SPECIALITE",

  GET_THEMES: "GET_THEMES",
  GET_THEME: "GET_THEME",
  GET_UES: "GET_UES",
  GET_UES: "GET_UE",
  GET_ECS: "GET_ECS",
  GET_EC: "GET_EC",

  GET_QUIZ: "GET_QUIZ",
  GET_QUIZ_BY_ID: "GET_QUIZ_BY_ID",

  SET_LOAD: "SET_LOAD",
};
